import { ChartUtilResult } from '@/components/General/PlayerChart';
import { Parameter } from '@/pages/InteractiveSimulation/types/replayInteractive';

export interface WebSocketDataPoint {
	paramId: number;
	value: number;
	last: boolean;
	time: string;
}


export function processWebSocketDataPoint(
	point: WebSocketDataPoint,
	parameters: Parameter[],
	chartDataMap: Map<number, ChartUtilResult>
): boolean {
	const paramId = point.paramId;
	const selectedParamIds = new Set(parameters.map(p => p.paremeterId));
	
	if (!selectedParamIds.has(paramId)) {
		return false;
	}
	
	const timestamp = new Date(point.time).getTime();
	const value = point.value;
	

	if (isNaN(timestamp) || value === undefined || value === null) {
		return false;
	}
	
	const parameter = parameters.find((p) => p.paremeterId === paramId);
	let seriesData = chartDataMap.get(paramId);
	

	if (!seriesData) {
		const infraName = parameter?.infraestructureName ?? 'Unknown Infrastructure';
		const paramName = parameter?.paremeterName ?? `Parameter ${paramId}`;
		const seriesName = `${infraName} | ${paramName}`;
		
		
		seriesData = {
			info: {
				name: seriesName,
			},
			data: [],
			paramId: String(paramId),
		};
		chartDataMap.set(paramId, seriesData);
	}
	

	seriesData.data.push({
		x: timestamp,
		y: value,
	});
	
	seriesData.data.sort((a, b) => a.x - b.x);
	
	return true;
}

export function cleanUnselectedParameters(
	parameters: Parameter[],
	chartDataMap: Map<number, ChartUtilResult>
): boolean {
	const selectedParamIds = new Set(parameters.map(p => p.paremeterId));
	const keysToDelete: number[] = [];
	
	chartDataMap.forEach((_, paramId) => {
		if (!selectedParamIds.has(paramId)) {
			keysToDelete.push(paramId);
		}
	});
	
	keysToDelete.forEach(paramId => {
		chartDataMap.delete(paramId);
	});
	
	return keysToDelete.length > 0;
}

export function chartDataMapToArray(chartDataMap: Map<number, ChartUtilResult>): ChartUtilResult[] {
	return Array.from(chartDataMap.values());
}
